module.exports = __webpack_public_path__ + "img/IMG_3501.a78eb29f.jpg";